import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const TYPE_LABEL = '[Type: Label][Vis: high] - Feature Set List Item';

export default defineMessages({
  '508_accessibility': {
    id: 'Pricing.copy.Summary508Accessibility',
    defaultMessage: 'ADA compliant',
    desc: {
      id: 'Pricing.copy.Summary508Accessibility',
      message: `${TYPE_LABEL} - Summary508Accessibility`,
      project: PROJECT_NAME,
    },
  },
  a_b_testing: {
    id: 'Pricing.copy.SummaryABTestingOverride',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: {
      id: 'Pricing.copy.SummaryABTestingOverride',
      message: `${TYPE_LABEL} - SummaryABTestingOverride`,
      project: PROJECT_NAME,
    },
  },
  account_control: {
    id: 'Pricing.copy.SummaryAccountControl',
    defaultMessage: 'Account control and migration',
    desc: {
      id: 'Pricing.copy.SummaryAccountControl',
      message: `${TYPE_LABEL} - SummaryAccountControl`,
      project: PROJECT_NAME,
    },
  },
  add_users: {
    id: 'Pricing.copy.SummaryAddUsers',
    defaultMessage: 'Add Users',
    desc: {
      id: 'Pricing.copy.SummaryAddUsers',
      message: `${TYPE_LABEL} - SummaryAddUsers`,
      project: PROJECT_NAME,
    },
  },
  admin_dashboard: {
    id: 'Pricing.copy.SummaryAdminDashboard',
    defaultMessage: 'Admin dashboard and user management',
    desc: {
      id: 'Pricing.copy.SummaryAdminDashboard',
      message: `${TYPE_LABEL} - SummaryAdminDashboard`,
      project: PROJECT_NAME,
    },
  },
  advanced_analyze_features: {
    id: 'Pricing.copy.SummaryAdvancedAnalyzeFeatures',
    defaultMessage: 'Advanced analyze features',
    desc: {
      id: 'Pricing.copy.SummaryAdvancedAnalyzeFeatures',
      message: `${TYPE_LABEL} - SummaryAdvancedAnalyzeFeatures`,
      project: PROJECT_NAME,
    },
  },
  advanced_collaboration: {
    id: 'Pricing.copy.SummaryAdvancedCollaborationFeatures',
    defaultMessage: 'Advanced collaboration features',
    desc: {
      id: 'Pricing.copy.SummaryAdvancedCollaborationFeatures',
      message: `${TYPE_LABEL} - `,
      project: PROJECT_NAME,
    },
  },
  advanced_logic: {
    id: 'Pricing.copy.SummaryAdvancedLogic',
    defaultMessage: 'Advanced survey logic tools',
    desc: {
      id: 'Pricing.copy.SummaryAdvancedLogic',
      message: `${TYPE_LABEL} - SummaryAdvancedLogic`,
      project: PROJECT_NAME,
    },
  },
  all_data_exports: {
    id: 'Pricing.copy.SummaryAllDataExports',
    defaultMessage: 'All data exports (CSV, XLS, PPT, PDF, SPSS)',
    desc: {
      id: 'Pricing.copy.SummaryAllDataExports',
      message: `${TYPE_LABEL} - SummaryAllDataExports`,
      project: PROJECT_NAME,
    },
  },
  all_languages_supported: {
    id: 'Pricing.copy.SummaryAllLanguagesSupported',
    defaultMessage: 'All Languages Supported',
    desc: {
      id: 'Pricing.copy.SummaryAllLanguagesSupported',
      message: `${TYPE_LABEL} - SummaryAllLanguagesSupported`,
      project: PROJECT_NAME,
    },
  },
  analyze_can_share_customize_branding: {
    id: 'Pricing.copy.SummaryAnalyzeCanShareCustomizeBranding',
    defaultMessage: 'Customization and branding',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeCanShareCustomizeBranding',
      message: `${TYPE_LABEL} - SummaryAnalyzeCanShareCustomizeBranding`,
      project: PROJECT_NAME,
    },
  },
  analyze_combine_filters: {
    id: 'Pricing.copy.SummaryCombineFilters',
    defaultMessage: 'Unlimited filter and compare rules, data trends',
    desc: {
      id: 'Pricing.copy.SummaryCombineFilters',
      message: `${TYPE_LABEL} - SummaryCombineFilters`,
      project: PROJECT_NAME,
    },
  },
  analyze_export_enabled: {
    id: 'Pricing.copy.SummaryAnalyzeExportEnabled',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeExportEnabled',
      message: `${TYPE_LABEL} - SummaryAnalyzeExportEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_export_spss_enabled: {
    id: 'Pricing.copy.SummaryAnalyzeExportSpssEnabled',
    defaultMessage: 'Advanced data exports (SPSS)',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeExportSpssEnabled',
      message: `${TYPE_LABEL} - SummaryAnalyzeExportSpssEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_integrations: {
    id: 'Pricing.copy.SummaryAnalyzeIntegrations',
    defaultMessage: 'Free integrations with popular collaboration apps',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeIntegrations',
      message: `${TYPE_LABEL} - SummaryAnalyzeIntegrations`,
      project: PROJECT_NAME,
    },
  },
  analyze_results_together: {
    id: 'Pricing.copy.SummaryAnalyzeResultsTogether',
    defaultMessage: 'Let team members analyze, filter, and export results',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeResultsTogether',
      message: `${TYPE_LABEL} - SummaryAnalyzeResultsTogether`,
      project: PROJECT_NAME,
    },
  },
  sentiment: {
    id: 'Pricing.copy.SummaryAnalyzeSentimentEnabled',
    defaultMessage: 'Sentiment analysis',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeSentimentEnabled',
      message: `${TYPE_LABEL} - SummaryAnalyzeSentimentEnabled`,
      project: PROJECT_NAME,
    },
  },
  analyze_trends_enabled: {
    id: 'Pricing.copy.SummaryAnalyzeTrendsEnabled',
    defaultMessage: '1 filter',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeTrendsEnabled',
      message: `${TYPE_LABEL} - SummaryAnalyzeTrendsEnabled`,
      project: PROJECT_NAME,
    },
  },
  asset_library: {
    id: 'Pricing.copy.SummaryAssetLibrary',
    defaultMessage: 'Shared asset library for on-brand surveys',
    desc: {
      id: 'Pricing.copy.SummaryAssetLibrary',
      message: `${TYPE_LABEL} - SummaryAssetLibrary`,
      project: PROJECT_NAME,
    },
  },
  base_response_count: {
    id: 'Pricing.copy.SummaryBaseResponseCount',
    defaultMessage: '{amount} responses per year**',
    desc: {
      id: 'Pricing.copy.SummaryBaseResponseCount',
      message: `${TYPE_LABEL} - SummaryBaseResponseCount`,
      project: PROJECT_NAME,
    },
  },
  benchmarks: {
    id: 'Pricing.copy.SummaryBenchmarks',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: {
      id: 'Pricing.copy.SummaryBenchmarks',
      message: `${TYPE_LABEL} - SummaryBenchmarks`,
      project: PROJECT_NAME,
    },
  },
  block_randomization: {
    id: 'Pricing.copy.SummaryBlockRandomization',
    defaultMessage: 'Block randomization',
    desc: {
      id: 'Pricing.copy.SummaryBlockRandomization',
      message: `${TYPE_LABEL} - SummaryBlockRandomization`,
      project: PROJECT_NAME,
    },
  },
  build_surveys_together: {
    id: 'Pricing.copy.SummaryBuildSurveysTogether',
    defaultMessage: 'Build Surveys Together',
    desc: {
      id: 'Pricing.copy.SummaryBuildSurveysTogether',
      message: `${TYPE_LABEL} - SummaryBuildSurveysTogether`,
      project: PROJECT_NAME,
    },
  },
  carry_forward: {
    id: 'Pricing.copy.SummaryCarryForward',
    defaultMessage: 'Carry Forward',
    desc: {
      id: 'Pricing.copy.SummaryCarryForward',
      message: `${TYPE_LABEL} - SummaryCarryForward`,
      project: PROJECT_NAME,
    },
  },
  click_map_qt: {
    id: 'Pricing.copy.SummaryClickMapQT',
    defaultMessage: 'Click map data visualization',
    desc: {
      id: 'Pricing.copy.SummaryClickMapQT',
      message: `${TYPE_LABEL} - SummaryClickMapQT`,
      project: PROJECT_NAME,
    },
  },
  collaborate: {
    id: 'Pricing.copy.SummaryCollaborate',
    defaultMessage: 'Survey sharing with fine control over who can view and edit',
    desc: {
      id: 'Pricing.copy.SummaryCollaborate',
      message: `${TYPE_LABEL} - SummaryCollaborate`,
      project: PROJECT_NAME,
    },
  },
  collect_contact_information: {
    id: 'Pricing.copy.SummaryCollectContactInformation',
    defaultMessage: 'Contact Information',
    desc: {
      id: 'Pricing.copy.SummaryCollectContactInformation',
      message: `${TYPE_LABEL} - SummaryCollectContactInformation`,
      project: PROJECT_NAME,
    },
  },
  collector_completion_url_enabled: {
    id: 'Pricing.copy.SummaryCollectorCompletionUrlEnabled',
    defaultMessage: 'Survey completion redirect',
    desc: {
      id: 'Pricing.copy.SummaryCollectorCompletionUrlEnabled',
      message: `${TYPE_LABEL} - SummaryCollectorCompletionUrlEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_mobile_sdk_enabled: {
    id: 'Pricing.copy.SummaryCollectorMobileSdkEnabled',
    defaultMessage: 'Mobile SDK',
    desc: {
      id: 'Pricing.copy.SummaryCollectorMobileSdkEnabled',
      message: `${TYPE_LABEL} - SummaryCollectorMobileSdkEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_popup_enabled: {
    id: 'Pricing.copy.SummaryCollectorPopupEnabled',
    defaultMessage: 'Pop up online surveys',
    desc: {
      id: 'Pricing.copy.SummaryCollectorPopupEnabled',
      message: `${TYPE_LABEL} - SummaryCollectorPopupEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_friendly_url_enabled: {
    id: 'Pricing.copy.SummaryCollectorFriendlyUrlEnabled',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: {
      id: 'Pricing.copy.SummaryCollectorFriendlyUrlEnabled',
      message: `${TYPE_LABEL} - SummaryCollectorFriendlyUrlEnabled`,
      project: PROJECT_NAME,
    },
  },
  collector_white_label_enabled: {
    id: 'Pricing.copy.SummaryCollectorWhiteLabelEnabled',
    defaultMessage: 'White label surveys',
    desc: {
      id: 'Pricing.copy.SummaryCollectorWhiteLabelEnabled',
      message: `${TYPE_LABEL} - SummaryCollectorWhiteLabelEnabled`,
      project: PROJECT_NAME,
    },
  },
  consolidated_billing: {
    id: 'Pricing.copy.SummaryConsolidatedBilling',
    defaultMessage: 'Consolidated Billing',
    desc: {
      id: 'Pricing.copy.SummaryConsolidatedBilling',
      message: `${TYPE_LABEL} - SummaryConsolidatedBilling`,
      project: PROJECT_NAME,
    },
  },
  contributor_seats: {
    id: 'Pricing.copy.SummaryContributorSeats',
    defaultMessage: 'Add Contributor Seats',
    desc: {
      id: 'Pricing.copy.SummaryContributorSeats',
      message: `${TYPE_LABEL} - SummaryContributorSeats`,
      project: PROJECT_NAME,
    },
  },
  create_advanced_features: {
    id: 'Pricing.copy.SummaryCreateAdvancedFeatures',
    defaultMessage: 'A/B testing, randomization, quotas',
    desc: {
      id: 'Pricing.copy.SummaryCreateAdvancedFeatures',
      message: `${TYPE_LABEL} - SummaryCreateAdvancedFeatures`,
      project: PROJECT_NAME,
    },
  },
  create_custom_theme_enabled: {
    id: 'Pricing.copy.SummaryCreateCustomThemeEnabled',
    defaultMessage: 'Create Custom Theme',
    desc: {
      id: 'Pricing.copy.SummaryCreateCustomThemeEnabled',
      message: `${TYPE_LABEL} - SummaryCreateCustomThemeEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_custom_variables_enabled: {
    id: 'Pricing.copy.SummaryCreateCustomVariablesEnabled',
    defaultMessage: 'Custom variables',
    desc: {
      id: 'Pricing.copy.SummaryCreateCustomVariablesEnabled',
      message: `${TYPE_LABEL} - SummaryCreateCustomVariablesEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_piping_enabled: {
    id: 'Pricing.copy.SummaryCreatePipingEnabled',
    defaultMessage: 'Skip logic, question & answer piping',
    desc: {
      id: 'Pricing.copy.SummaryCreatePipingEnabled',
      message: `${TYPE_LABEL} - SummaryCreatePipingEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_question_limit: {
    id: 'Pricing.copy.SummaryCreateQuestionLimit',
    defaultMessage: 'Unlimited surveys and questions',
    desc: {
      id: 'Pricing.copy.SummaryCreateQuestionLimit',
      message: `${TYPE_LABEL} - SummaryCreateQuestionLimit`,
      project: PROJECT_NAME,
    },
  },
  skip_logic: {
    id: 'Pricing.copy.SummaryCreateSkipLogicEnabled',
    defaultMessage: 'Skip logic only',
    desc: {
      id: 'Pricing.copy.SummaryCreateSkipLogicEnabled',
      message: `${TYPE_LABEL} - SummaryCreateSkipLogicEnabled`,
      project: PROJECT_NAME,
    },
  },
  create_toggle_footer_enabled: {
    id: 'Pricing.copy.SummaryCreateToggleFooterEnabled',
    defaultMessage: 'Hide SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.SummaryCreateToggleFooterEnabled',
      message: `${TYPE_LABEL} - SummaryCreateToggleFooterEnabled`,
      project: PROJECT_NAME,
    },
  },
  custom_templates: {
    id: 'Pricing.copy.SummaryCustomTemplates',
    defaultMessage: 'Custom Templates',
    desc: {
      id: 'Pricing.copy.SummaryCustomTemplates',
      message: `${TYPE_LABEL} - SummaryCustomTemplates`,
      project: PROJECT_NAME,
    },
  },
  customer_success: {
    id: 'Pricing.copy.SummaryCustomerSuccess',
    defaultMessage: 'Dedicated customer success manager***',
    desc: {
      id: 'Pricing.copy.SummaryCustomerSuccess',
      message: `${TYPE_LABEL} - SummaryCustomerSuccess`,
      project: PROJECT_NAME,
    },
  },
  download_as_ppt: {
    id: 'Pricing.copy.SummaryDownloadAsPpt',
    defaultMessage: 'Download as PPT',
    desc: {
      id: 'Pricing.copy.SummaryDownloadAsPpt',
      message: `${TYPE_LABEL} - SummaryDownloadAsPpt`,
      project: PROJECT_NAME,
    },
  },
  email_support: {
    id: 'Pricing.copy.SummaryEmailSupport',
    defaultMessage: '24/7 customer support via email',
    desc: {
      id: 'Pricing.copy.SummaryEmailSupport',
      message: `${TYPE_LABEL} - SummaryEmailSupport`,
      project: PROJECT_NAME,
    },
  },
  enable_ip_blocking: {
    id: 'Pricing.copy.SummaryEnableIpBlocking',
    defaultMessage: 'Enable IP Blocking',
    desc: {
      id: 'Pricing.copy.SummaryEnableIpBlocking',
      message: `${TYPE_LABEL} - SummaryEnableIpBlocking`,
      project: PROJECT_NAME,
    },
  },
  enhanced_governance: {
    id: 'Pricing.copy.SummaryEnhancedGovernance',
    defaultMessage: 'Enhanced governance and security features',
    desc: {
      id: 'Pricing.copy.SummaryEnhancedGovernance',
      message: `${TYPE_LABEL} - SummaryEnhancedGovernance`,
      project: PROJECT_NAME,
    },
  },
  essential_question_types: {
    id: 'Pricing.copy.SummaryEssentialQuestionTypes',
    defaultMessage: 'Essential question types',
    desc: {
      id: 'Pricing.copy.SummaryEssentialQuestionTypes',
      message: `${TYPE_LABEL} - SummaryEssentialQuestionTypes`,
      project: PROJECT_NAME,
    },
  },
  extended_piping: {
    id: 'Pricing.copy.SummaryExtendedPiping',
    defaultMessage: 'Advanced branching & piping, block randomization',
    desc: {
      id: 'Pricing.copy.SummaryExtendedPiping',
      message: `${TYPE_LABEL} - SummaryExtendedPiping`,
      project: PROJECT_NAME,
    },
  },
  extract_data: {
    id: 'Pricing.copy.SummaryExtractData',
    defaultMessage: 'Extract data',
    desc: {
      id: 'Pricing.copy.SummaryExtractData',
      message: `${TYPE_LABEL} - SummaryExtractData`,
      project: PROJECT_NAME,
    },
  },
  file_upload: {
    id: 'Pricing.copy.SummaryFileUpload',
    defaultMessage: 'File upload',
    desc: {
      id: 'Pricing.copy.SummaryFileUpload',
      message: `${TYPE_LABEL} - SummaryFileUpload`,
      project: PROJECT_NAME,
    },
  },
  flexible_plan_types: {
    id: 'Pricing.copy.SummaryFlexiblePlanTypes',
    defaultMessage: 'Flexible plan types for multiple users',
    desc: {
      id: 'Pricing.copy.SummaryFlexiblePlanTypes',
      message: `${TYPE_LABEL} - SummaryFlexiblePlanTypes`,
      project: PROJECT_NAME,
    },
  },
  footer_branding: {
    id: 'Pricing.copy.SummaryAnalyzeCanExportHideBranding',
    defaultMessage: 'Remove SurveyMonkey footer',
    desc: {
      id: 'Pricing.copy.SummaryAnalyzeCanExportHideBranding',
      message: `${TYPE_LABEL} - SummaryAnalyzeCanExportHideBranding`,
      project: PROJECT_NAME,
    },
  },
  gather_comments: {
    id: 'Pricing.copy.SummaryGatherComments',
    defaultMessage: 'Gather comments all in one place',
    desc: {
      id: 'Pricing.copy.SummaryGatherComments',
      message: `${TYPE_LABEL} - SummaryGatherComments`,
      project: PROJECT_NAME,
    },
  },
  hipaa_enabled: {
    id: 'Pricing.copy.SummaryHipaaEnabled',
    defaultMessage: 'HIPAA-compliant features***',
    desc: {
      id: 'Pricing.copy.SummaryHipaaEnabled',
      message: `${TYPE_LABEL} - SummaryHipaaEnabled`,
      project: PROJECT_NAME,
    },
  },
  integrations: {
    id: 'Pricing.copy.SummaryIntegrations',
    defaultMessage: 'Integrations with Salesforce, Marketo, Eloqua, and Tableau***',
    desc: {
      id: 'Pricing.copy.SummaryIntegrations',
      message: `${TYPE_LABEL} - `,
      project: PROJECT_NAME,
    },
  },
  kiosk_mode_inactivity_timer: {
    id: 'Pricing.copy.SummaryKioskModeInactivityTimer',
    defaultMessage: 'Kiosk Mode Inactivity Timer',
    desc: {
      id: 'Pricing.copy.SummaryKioskModeInactivityTimer',
      message: `${TYPE_LABEL} - SummaryKioskModeInactivityTimer`,
      project: PROJECT_NAME,
    },
  },
  kiosk_mode_passcode_lock: {
    id: 'Pricing.copy.SummaryKioskModePasscodeLock',
    defaultMessage: 'Kiosk Mode Passcode Lock',
    desc: {
      id: 'Pricing.copy.SummaryKioskModePasscodeLock',
      message: `${TYPE_LABEL} - SummaryKioskModePasscodeLock`,
      project: PROJECT_NAME,
    },
  },
  matrix_question_type: {
    id: 'Pricing.copy.SummaryMatrixQuestionType',
    defaultMessage: 'Matrix Question Type',
    desc: {
      id: 'Pricing.copy.SummaryMatrixQuestionType',
      message: `${TYPE_LABEL} - SummaryMatrixQuestionType`,
      project: PROJECT_NAME,
    },
  },
  multilingual: {
    id: 'Pricing.copy.SummaryMultilingual',
    defaultMessage: 'Multilingual surveys',
    desc: {
      id: 'Pricing.copy.SummaryMultilingual',
      message: `${TYPE_LABEL} - `,
      project: PROJECT_NAME,
    },
  },
  num_free_responses: {
    id: 'Pricing.copy.SummaryNumFreeResponses',
    defaultMessage: '{amount} responses per month**',
    desc: {
      id: 'Pricing.copy.SummaryNumFreeResponses',
      message: `${TYPE_LABEL} - SummaryNumFreeResponses`,
      project: PROJECT_NAME,
    },
  },
  pagination: {
    id: 'Pricing.copy.SummaryPagination',
    defaultMessage: 'Pagination',
    desc: {
      id: 'Pricing.copy.SummaryPagination',
      message: `${TYPE_LABEL} - SummaryPagination`,
      project: PROJECT_NAME,
    },
  },
  password_protection: {
    id: 'Pricing.copy.SummaryPasswordProtection',
    defaultMessage: 'Password Protection',
    desc: {
      id: 'Pricing.copy.SummaryPasswordProtection',
      message: `${TYPE_LABEL} - SummaryPasswordProtection`,
      project: PROJECT_NAME,
    },
  },
  payment_qt: {
    id: 'Pricing.copy.SummaryPaymentQT',
    defaultMessage: 'Accept payments',
    desc: {
      id: 'Pricing.copy.SummaryPaymentQT',
      message: `${TYPE_LABEL} - `,
      project: PROJECT_NAME,
    },
  },
  phone_support: {
    id: 'Pricing.copy.SummaryPhoneSupport',
    defaultMessage: 'Phone support and 24/7 email support',
    desc: {
      id: 'Pricing.copy.SummaryPhoneSupport',
      message: `${TYPE_LABEL} - SummaryPhoneSupport`,
      project: PROJECT_NAME,
    },
  },
  benchmark_logic: {
    id: 'Pricing.copy.SummaryPlansBenchmark',
    defaultMessage: 'SurveyMonkey industry benchmarks',
    desc: {
      id: 'Pricing.copy.SummaryPlansBenchmark',
      message: `${TYPE_LABEL} - SummaryPlansBenchmark`,
      project: PROJECT_NAME,
    },
  },
  pop_up_collector: {
    id: 'Pricing.copy.SummaryPopupCollector',
    defaultMessage: 'Popup Collector',
    desc: {
      id: 'Pricing.copy.SummaryPopupCollector',
      message: `${TYPE_LABEL} - SummaryPopupCollector`,
      project: PROJECT_NAME,
    },
  },
  premium_themes: {
    id: 'Pricing.copy.SummaryPremiumThemes',
    defaultMessage: 'Premium Themes',
    desc: {
      id: 'Pricing.copy.SummaryPremiumThemes',
      message: `${TYPE_LABEL} - SummaryPremiumThemes`,
      project: PROJECT_NAME,
    },
  },
  priority_email_support: {
    id: 'Pricing.copy.SummaryPrimaryEmailSupport',
    defaultMessage: '24/7 expedited email support',
    desc: {
      id: 'Pricing.copy.SummaryPrimaryEmailSupport',
      message: `${TYPE_LABEL} - SummaryPrimaryEmailSupport`,
      project: PROJECT_NAME,
    },
  },
  private_apps: {
    id: 'Pricing.copy.SummaryPrivateApps',
    defaultMessage: 'Unlimited API access***',
    desc: {
      id: 'Pricing.copy.SummaryPrivateApps',
      message: `${TYPE_LABEL} - SummaryPrivateApps`,
      project: PROJECT_NAME,
    },
  },
  progress_bar: {
    id: 'Pricing.copy.SummaryProgressBar',
    defaultMessage: 'Progress Bar',
    desc: {
      id: 'Pricing.copy.SummaryProgressBar',
      message: `${TYPE_LABEL} - SummaryProgressBar`,
      project: PROJECT_NAME,
    },
  },
  question_library: {
    id: 'Pricing.copy.SummaryQuestionLibrary',
    defaultMessage: 'Question Library',
    desc: {
      id: 'Pricing.copy.SummaryQuestionLibrary',
      message: `${TYPE_LABEL} - SummaryQuestionLibrary`,
      project: PROJECT_NAME,
    },
  },
  quizzes_pro: {
    id: 'Pricing.copy.SummaryQuizzesPro',
    defaultMessage: 'Quizzes with custom feedback',
    desc: {
      id: 'Pricing.copy.SummaryQuizzesPro',
      message: `${TYPE_LABEL} - SummaryQuizzesPro`,
      project: PROJECT_NAME,
    },
  },
  randomize_answer_choices: {
    id: 'Pricing.copy.SummaryRandomizeAnswerChoices',
    defaultMessage: 'Randomize Answer Choices',
    desc: {
      id: 'Pricing.copy.SummaryRandomizeAnswerChoices',
      message: `${TYPE_LABEL} - SummaryRandomizeAnswerChoices`,
      project: PROJECT_NAME,
    },
  },
  ranking_question_type: {
    id: 'Pricing.copy.SummaryRankingQuestionType',
    defaultMessage: 'Ranking Question Type',
    desc: {
      id: 'Pricing.copy.SummaryRankingQuestionType',
      message: `${TYPE_LABEL} - SummaryRankingQuestionType`,
      project: PROJECT_NAME,
    },
  },
  rating_question_type: {
    id: 'Pricing.copy.SummaryRatingQuestionType',
    defaultMessage: 'Rating Question Type',
    desc: {
      id: 'Pricing.copy.SummaryRatingQuestionType',
      message: `${TYPE_LABEL} - SummaryRatingQuestionType`,
      project: PROJECT_NAME,
    },
  },
  real_time_results: {
    id: 'Pricing.copy.SummaryRealTimeResults',
    defaultMessage: 'Real Time Results',
    desc: {
      id: 'Pricing.copy.SummaryRealTimeResults',
      message: `${TYPE_LABEL} - SummaryRealTimeResults`,
      project: PROJECT_NAME,
    },
  },
  record_respondent_email_address: {
    id: 'Pricing.copy.SummaryRecordRespondentEmailAddress',
    defaultMessage: 'Record Respondent Email Address',
    desc: {
      id: 'Pricing.copy.SummaryRecordRespondentEmailAddress',
      message: `${TYPE_LABEL} - SummaryRecordRespondentEmailAddress`,
      project: PROJECT_NAME,
    },
  },
  recurring_surveys: {
    id: 'Pricing.copy.SummaryRecurringSurveys',
    defaultMessage: 'Recurring Surveys',
    desc: {
      id: 'Pricing.copy.SummaryRecurringSurveys',
      message: `${TYPE_LABEL} - SummaryRecurringSurveys`,
      project: PROJECT_NAME,
    },
  },
  response_alerts: {
    id: 'Pricing.copy.SummaryResponseAlerts',
    defaultMessage: 'Notify others when you get new responses',
    desc: {
      id: 'Pricing.copy.SummaryResponseAlerts',
      message: `${TYPE_LABEL} - SummaryResponseAlerts`,
      project: PROJECT_NAME,
    },
  },
  response_quality_enabled: {
    id: 'Pricing.copy.SummaryResponseQualityEnabled',
    defaultMessage: 'Response Quality',
    desc: {
      id: 'Pricing.copy.SummaryResponseQualityEnabled',
      message: `${TYPE_LABEL} - SummaryResponseQualityEnabled`,
      project: PROJECT_NAME,
    },
  },
  send_surveys: {
    id: 'Pricing.copy.SummarySendSurveys',
    defaultMessage: 'Send Surveys',
    desc: {
      id: 'Pricing.copy.SummarySendSurveys',
      message: `${TYPE_LABEL} - SummarySendSurveys`,
      project: PROJECT_NAME,
    },
  },
  set_max_response_count: {
    id: 'Pricing.copy.SummarySetMaxResponseCount',
    defaultMessage: 'Set Max Response Count',
    desc: {
      id: 'Pricing.copy.SummarySetMaxResponseCount',
      message: `${TYPE_LABEL} - SummarySetMaxResponseCount`,
      project: PROJECT_NAME,
    },
  },
  set_survey_end_date: {
    id: 'Pricing.copy.SummarySetSurveyEndDate',
    defaultMessage: 'Set Survey End Date',
    desc: {
      id: 'Pricing.copy.SummarySetSurveyEndDate',
      message: `${TYPE_LABEL} - SummarySetSurveyEndDate`,
      project: PROJECT_NAME,
    },
  },
  share_surveys: {
    id: 'Pricing.copy.SummaryShareSurveys',
    defaultMessage: 'Share Surveys',
    desc: {
      id: 'Pricing.copy.SummaryShareSurveys',
      message: `${TYPE_LABEL} - SummaryShareSurveys`,
      project: PROJECT_NAME,
    },
  },
  shared_assets: {
    id: 'Pricing.copy.SummarySharedAssets',
    defaultMessage: 'Shared asset library for on-brand surveys',
    desc: {
      id: 'Pricing.copy.SummarySharedAssets',
      message: `${TYPE_LABEL} - SummarySharedAssets`,
      project: PROJECT_NAME,
    },
  },
  shared_library: {
    id: 'Pricing.copy.SummarySharedLibrary',
    defaultMessage: 'Shared Library',
    desc: {
      id: 'Pricing.copy.SummarySharedLibrary',
      message: `${TYPE_LABEL} - SummarySharedLibrary`,
      project: PROJECT_NAME,
    },
  },
  show_create_crosstab: {
    id: 'Pricing.copy.SummaryShowCreateCrosstab',
    defaultMessage: 'Crosstabs',
    desc: {
      id: 'Pricing.copy.SummaryShowCreateCrosstab',
      message: `${TYPE_LABEL} - SummaryShowCreateCrosstab`,
      project: PROJECT_NAME,
    },
  },
  single_sign_on: {
    id: 'Pricing.copy.SummarySingleSignOn',
    defaultMessage: 'Single sign-on (SSO)',
    desc: {
      id: 'Pricing.copy.SummarySingleSignOn',
      message: `${TYPE_LABEL} - SummarySingleSignOn`,
      project: PROJECT_NAME,
    },
  },
  slider_question_type: {
    id: 'Pricing.copy.SummarySliderQuestionType',
    defaultMessage: 'Slider Question Type',
    desc: {
      id: 'Pricing.copy.SummarySliderQuestionType',
      message: `${TYPE_LABEL} - SummarySliderQuestionType`,
      project: PROJECT_NAME,
    },
  },
  statistical_significance: {
    id: 'Pricing.copy.SummaryStatisticalSignificance',
    defaultMessage: 'Text analysis & statistical significance',
    desc: {
      id: 'Pricing.copy.SummaryStatisticalSignificance',
      message: `${TYPE_LABEL} - SummaryStatisticalSignificance`,
      project: PROJECT_NAME,
    },
  },
  survey_branding: {
    id: 'Pricing.copy.SummarySurveyBranding',
    defaultMessage: 'Custom logo, colors, and survey URL',
    desc: {
      id: 'Pricing.copy.SummarySurveyBranding',
      message: `${TYPE_LABEL} - SummarySurveyBranding`,
      project: PROJECT_NAME,
    },
  },
  survey_create_limit: {
    id: 'Pricing.copy.SummarySurveyCreateLimit',
    defaultMessage: 'Unlimited number of surveys',
    desc: {
      id: 'Pricing.copy.SummarySurveyCreateLimit',
      message: `${TYPE_LABEL} - SummarySurveyCreateLimit`,
      project: PROJECT_NAME,
    },
  },
  team_activity: {
    id: 'Pricing.copy.SummaryTeamActivity',
    defaultMessage: 'Activity tracking through audit logs',
    desc: {
      id: 'Pricing.copy.SummaryTeamActivity',
      message: `${TYPE_LABEL} - SummaryTeamActivity`,
      project: PROJECT_NAME,
    },
  },
  team_logic: {
    id: 'Pricing.copy.SummaryTeamLogic',
    defaultMessage: 'Add or reassign accounts at any time',
    desc: {
      id: 'Pricing.copy.SummaryTeamLogic',
      message: `${TYPE_LABEL} - SummaryTeamLogic`,
      project: PROJECT_NAME,
    },
  },
  team_ownership: {
    id: 'Pricing.copy.SummaryTeamOwnership',
    defaultMessage: 'Team Ownership',
    desc: {
      id: 'Pricing.copy.SummaryTeamOwnership',
      message: `${TYPE_LABEL} - SummaryTeamOwnership`,
      project: PROJECT_NAME,
    },
  },
  team_themes: {
    id: 'Pricing.copy.SummaryTeamThemes',
    defaultMessage: 'Team Themes',
    desc: {
      id: 'Pricing.copy.SummaryTeamThemes',
      message: `${TYPE_LABEL} - SummaryTeamThemes`,
      project: PROJECT_NAME,
    },
  },
  text_analysis: {
    id: 'Pricing.copy.SummaryTextAnalysis',
    defaultMessage: 'Text analysis',
    desc: {
      id: 'Pricing.copy.SummaryTextAnalysis',
      message: `${TYPE_LABEL} - SummaryTextAnalysis`,
      project: PROJECT_NAME,
    },
  },
  text_formatting: {
    id: 'Pricing.copy.SummaryTextFormatting',
    defaultMessage: 'Text Formatting',
    desc: {
      id: 'Pricing.copy.SummaryTextFormatting',
      message: `${TYPE_LABEL} - SummaryTextFormatting`,
      project: PROJECT_NAME,
    },
  },
  track_email_responses: {
    id: 'Pricing.copy.SummaryTrackEmailResponses',
    defaultMessage: 'Track Email Responses',
    desc: {
      id: 'Pricing.copy.SummaryTrackEmailResponses',
      message: `${TYPE_LABEL} - SummaryTrackEmailResponses`,
      project: PROJECT_NAME,
    },
  },
  unlimited_questions: {
    id: 'Pricing.copy.SummaryUnlimitedQuestions',
    defaultMessage: 'Unlimited questions per survey',
    desc: {
      id: 'Pricing.copy.SummaryUnlimitedQuestions',
      message: `${TYPE_LABEL} - SummaryUnlimitedQuestions`,
      project: PROJECT_NAME,
    },
  },
  unlimited_responses: {
    id: 'Pricing.copy.SummaryUnlimitedResponses',
    defaultMessage: 'Unlimited surveys and questions',
    desc: {
      id: 'Pricing.copy.SummaryUnlimitedResponses',
      message: `${TYPE_LABEL} - SummaryUnlimitedResponses`,
      project: PROJECT_NAME,
    },
  },
  user_management: {
    id: 'Pricing.copy.SummaryUserManagement',
    defaultMessage: 'User Management',
    desc: {
      id: 'Pricing.copy.SummaryUserManagement',
      message: `${TYPE_LABEL} - SummaryUserManagement`,
      project: PROJECT_NAME,
    },
  },
  validate_answer: {
    id: 'Pricing.copy.SummaryValidateAnswer',
    defaultMessage: 'Validate Answer',
    desc: {
      id: 'Pricing.copy.SummaryValidateAnswer',
      message: `${TYPE_LABEL} - SummaryValidateAnswer`,
      project: PROJECT_NAME,
    },
  },
  video_question_type: {
    id: 'Pricing.copy.SummaryVideoQuestionType',
    defaultMessage: 'Video Question Type',
    desc: {
      id: 'Pricing.copy.SummaryVideoQuestionType',
      message: `${TYPE_LABEL} - SummaryVideoQuestionType`,
      project: PROJECT_NAME,
    },
  },
  view_respondent_ip_address: {
    id: 'Pricing.copy.SummaryViewRespondentIpAddress',
    defaultMessage: `View respondent's IP address`,
    desc: {
      id: 'Pricing.copy.SummaryViewRespondentIpAddress',
      message: `${TYPE_LABEL} - SummaryViewRespondentIpAddress`,
      project: PROJECT_NAME,
    },
  },
});
